module.exports = __webpack_public_path__ + "static/img/goodsclassifyC.a4352d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goodsclassifyC.jpg
// module id = Iofu
// module chunks = 31